import React, { useEffect } from 'react';
import { inputChange, inputValidate } from '../../helpers/fieldFunctions';
import * as S from './Input.style';

export default function InputSelect({
  onChange,
  setFields,
  options,
  loadOptions,
  loadEmpty,
  name,
  disabled,
  isCreatable,
  filter,
  filterField,
  i,
  parentI,
  validate,
  onBlur,
  noOptionsMessage,
  ...props
}) {

  const loadOptionsHandler = (inputValue, callback) => {
    if (loadOptions) {
      if (!loadEmpty) {
        if (inputValue.length > 1) { loadOptions(inputValue, callback, setFields) }
      } else { loadOptions(inputValue, callback, setFields) }
    } else if (options) {
      callback(options)
    } else { callback([]) }
  };


  return (
    <S.InputSelect
      {...props}
      defaultOptions={options || true}
      id={name}
      name={name}
      key={filter}
      classNamePrefix="inputSelect"
      loadOptions={loadOptionsHandler}
      isDisabled={disabled}
      isValidNewOption={(inputValue) => isCreatable && inputValue.length > 2}
      formatCreateLabel={(inputValue) => inputValue}
      noOptionsMessage={() => noOptionsMessage || "Sem opções"}
      loadingMessage={() => "Carregando"}
      filterOption={(e) => {
        if (Array.isArray(filter)) {
          return filterField ? filter.some((item) => e.data[filterField]?.label === item.label) : true
        } else { return filterField ? filter === e.data[filterField]?.label : true }
      }}
      onChange={(value) => (
        onChange
          ? onChange({ target: { name, value, i }, setFields })
          : inputChange({ target: { name, value }, setFields })
      )}
      onBlur={({ target }) => inputValidate({ target: { ...target, i, value: props.value, parentI, name }, setFields, validate, onBlur })}
    />
  );
};
